import React, { Component } from 'react';
import { Calendar } from 'antd-mobile';
import { startTime, endTime, getTime } from 'common/util';
import moment from "moment";
import "./index.less";

export default class HistoryMenu extends Component {

    state = {
        tabIndex: 1, // 用于待办页切换菜单上面的导航栏
        statusIndex: 0, // 用于切换历史页的状态信息
        fstatusflag: '', // 用于切换历史页状态的一个标识
        startDate: null, // 用于选择开始日期
        endDate: null, // 用于选择结束日期
        dateIndex: 0, // 用于切换筛选日期
        carrierListData: [], // 存储承运商PK
        carrierListIndexData: [], // 用于切换承运商存储多选条件的信息
        show: false // 用于展示日历组件
    }

    // 用于存储承运商pk
    carrierListDataTemp = []
    // 用于存储筛选菜单各个状态
    menuStatus = {}

    historyMenuTabs = [
        { tabName: "单据状态", num: 1 },
        { tabName: "日期", num: 2 },
        // { tabName: "承运商", num: 3 }
    ]

    orderStatusData = [
        { name: "已完成", id: 1, fstatusflag: 0 },
        { name: "已作废", id: 2, fstatusflag: 1}
    ]

    dateChoiceData = [
        { 
            name: "当天", 
            id: 1, 
            startDate: new Date(Date.now()),
            endDate: new Date(Date.now())
        },
        { 
            name: "本周", 
            id: 2,
            startDate: new Date(Date.now() - startTime('week')*24*60*60*1000),
            endDate: new Date(Date.now() + endTime('week')*24*60*60*1000)
        },
        { 
            name: "上月", 
            id: 3,
            startDate: new Date(Date.now() - getTime()*24*60*60*1000),
            endDate: new Date(endTime('lastMonth'))
        },
        { 
            name: "本月", 
            id: 4,
            startDate: new Date(startTime('month')),
            endDate: new Date(endTime('month'))
        }
    ]
    // 切换菜单导航栏
    switchTab = (id) => {
        this.setState({
            tabIndex: id
        })
    }

    // 切换订单状态
    switchStatus = (id, fstatusflag) => {
        this.setState({
            statusIndex: id,
            fstatusflag
        })
    }

    // 切换筛选日期
    switchDate = (id, startDate, endDate) => {
        this.setState({
            dateIndex: id,
            startDate,
            endDate,
        })
    }

    // 切换承运商
    switchCarrier = (data, id) => {
        const { carrierListData, carrierListIndexData } = this.state;
        if(carrierListIndexData.includes(id)){
            carrierListIndexData.forEach((item, index)=>{
                if( id === item ){
                    carrierListIndexData.splice( index , 1);
                    carrierListData.splice( index , 1);
                }
            });
        } else {
            carrierListData.push(data.pk);
            carrierListIndexData.push(id);
        }
        this.setState({
            carrierListData,
            carrierListIndexData
        }, () => {
            this.carrierListDataTemp = [...carrierListData];//更新数组
        })
    }
    // 重置当前页面的操作
    resetInfo = ()=>{
        this.setState({
            statusIndex: 0,
            startDate: null,
            endDate: null,
            dateIndex: 0,
            carrierListIndexData: [],
            carrierListData:[],
            fstatusflag: ''
        }, () => {
            const { startDate, endDate, fstatusflag, carrierListData} = this.state;
            const { getHistorySubmitStatus } = this.props;
            this.menuStatus = {};
            this.carrierListDataTemp = [...carrierListData];
            getHistorySubmitStatus( "historyReset", startDate, endDate, this.carrierListDataTemp, fstatusflag );
        })
    }

    // 提交选中的信息
    submitInfo = () => {
        const { statusIndex, startDate, endDate, dateIndex, carrierListIndexData, carrierListData, fstatusflag } = this.state;

        this.menuStatus = Object.assign({}, this.menuStatus, {statusIndex}, {startDate}, {endDate}, {dateIndex}, {carrierListIndexData}, {carrierListData}, {fstatusflag} )
        const { getHistorySubmitStatus } = this.props;
        getHistorySubmitStatus( "historySubmit", startDate, endDate, this.carrierListDataTemp, fstatusflag );

    }

    // 重置之前选中的DatePicker日期
    cancelDateChoice = () => {
        this.setState({
            dateIndex: 0
        })
    }

    choiceDate = e => {
        if(e.target.dataset.type === "date"){
            this.setState({
                show:true
            })
        }
    }

    onCancel = ()=>{
        this.setState({
            show:false
        })
    }

    onConfirm = (startDate, endDate)=>{
        this.setState({
            show: false,
            startDate,
            endDate
        })
    }

    handleMenu = () => {
        if(Object.keys(this.menuStatus).length === 0){
            this.setState({
                statusIndex: 0,
                fstatusflag: '',
                startDate: null,
                endDate: null,
                dateIndex: 0,
                carrierListData: [],
                carrierListIndexData: []
            },() => {
                this.carrierListDataTemp = [...this.state.carrierListData];
            })
        }else{
            this.setState({
                statusIndex: this.menuStatus.statusIndex,
                fstatusflag: this.menuStatus.fstatusflag,
                startDate: this.menuStatus.startDate,
                endDate: this.menuStatus.endDate,
                dateIndex: this.menuStatus.dateIndex,
                carrierListData: [...this.menuStatus.carrierListData],
                carrierListIndexData: [...this.menuStatus.carrierListIndexData]
            },()=>{
                this.carrierListDataTemp = [...this.state.carrierListData];
            })
        }
    }

    componentDidMount(){
        this.props.onRef(this)
    }

    render() {
        const { showView, carrierData } = this.props;
        const { tabIndex, statusIndex, startDate, endDate, dateIndex, carrierListIndexData, show } = this.state;

        let history1Menu = tabIndex === 1 ? "block" : "none";
        let history2Menu = tabIndex === 2 ? "block" : "none";
        let history3Menu = tabIndex === 3 ? "block" : "none";
        let showMenu = showView ? "block" : "none";

        // 展示菜单的导航栏
        let historyMenuList = this.historyMenuTabs.map((item, index)=>{
            let menuStyle = item.num === tabIndex ? "menu-tab-container menu-tab-container-active" : "menu-tab-container"
            return  <div key={index} onClick={()=>{this.switchTab(item.num)}} className={menuStyle} >
                        <div className="menu-tab-title">{item.tabName}</div>
                    </div>
        })

        // 展示订单状态的按钮
        let statusList = this.orderStatusData.map((item,index)=>{
            let statusStyle = item.id === statusIndex ? "status-ctrl status-ctrl-active" : "status-ctrl";
            return  <button key={index} className={ statusStyle } onClick={()=>{this.switchStatus( item.id , item.fstatusflag )}}>{item.name}</button>
        })

        // 切换选择日期的按钮
        let dateChoiceList = this.dateChoiceData.map((item, index)=>{
            let dateChoiceStyle = item.id === dateIndex ? "date-switch date-switch-active" : "date-switch"
            return  <button key={index} className={dateChoiceStyle} onClick={()=>this.switchDate(item.id, item.startDate, item.endDate)}>{item.name}</button>  
                    
        })

        // 切换承运商
        let carrierList = carrierData?.map((item, index) => {
            let carrierStyle = carrierListIndexData.includes( index+1 ) ? "carrier-switch carrier-switch-active" :"carrier-switch"
            let showRight = carrierListIndexData.includes( index+1 ) ? "visible" : "hidden";
            return  <div key={item.pk} className={carrierStyle} onClick={()=>this.switchCarrier(item,index+1)}>
                        <div className="carrier-name">{item.name}</div>
                        <span className="carrier-choice" style={{visibility:showRight}}></span>
                    </div>
        })

        return (
            <div className="home-page-menu" style={{display:showMenu}}>
                <div className="menu-tab">{historyMenuList}</div>
                <div className="menu-container">
                    <div className="container-status" style={{display:history1Menu}}>{statusList}</div>
                    <div className="container-date" style={{display:history2Menu}}>
                        <div className="am-datepicker" onClick={this.choiceDate}>
                            <button data-type="date" className="date-choose-button-left" onClick={this.cancelDateChoice}>
                                {startDate ? moment(new Date(startDate)).format("YYYY-MM-DD") : "开始日期"}
                            </button>
                            <div className="date-link"></div>
                            <button data-type="date" className="date-choose-button-right" onClick={this.cancelDateChoice}>
                                {endDate ? moment(new Date(endDate)).format("YYYY-MM-DD") : "结束日期"}
                            </button>
                        </div>
                        <Calendar
                            visible = {show}
                            onCancel = {this.onCancel}
                            onConfirm = {this.onConfirm}
                            minDate = {new Date(Date.now() - getTime()*24*60*60*1000)}
                            defaultDate = {new Date(Date.now() - getTime()*24*60*60*1000)}
                            defaultValue = {[startDate, endDate]}
                        />
                        <div className="date-choice">{dateChoiceList}</div>
                    </div>
                    <div className="container-carrier" style={{display:history3Menu}}>
                        {carrierList}
                    </div>
                </div>
                <div className="menu-button">
                    <button type="reset" className="button-reset" onClick={this.resetInfo}>重置</button>
                    <button type="submit" className="button-right" onClick={this.submitInfo}>确定</button>
                </div>
            </div>
        )
    }
}
